import Image from "next/image";
import parse from "html-react-parser";
import { WhatYoullLearnProps } from "./types";

export default function WhatYoullLearn({
  title,
  parseContent,
  learningItems,
  areLearningItemsRTL,
  oneColumn = false,
}: WhatYoullLearnProps) {
  const hasList = (parseContent ?? "").includes("</li>");
  const columns = oneColumn
    ? "md:columns-1"
    : hasList || learningItems
      ? "md:columns-2 break-words line-break-strict max-w-full"
      : "md:columns-1";

  parseContent = parseContent?.replace(
    /<li>/g,
    '<li class="flex items-start pl-2 break-inside-avoid-column"><img src="/icons/bullet-point-icon.svg" alt="" class="mt-1 mr-4 align-middle"/><span class="flex-1">',
  );
  parseContent = parseContent?.replace(/<\/li>/g, "</span></li>");

  return (
    <div className="flex flex-col gap-6">
      {title && (
        <h2 className="my-0 text-primary md:text-3xl font-bold">{title}</h2>
      )}
      {(parseContent || learningItems) && (
        <div
          className={`
            ${columns} 
            [&>ul]:text-base [&>ul]:md:text-lg [&>ul]:text-gray-800 [&>ul]:gap-y-6 [&>ul]:md:gap-y-0 [&>ul]:md:gap-x-14 [&>ul]:px-4
            [&_li:not(:last-child)]:mb-6 [&_li]:font-sans
          `}
        >
          {parseContent && parse(parseContent)}
          {learningItems && (
            <ul
              // className="list-disc flex flex-col gap-1 list-inside mb-8"
              dir={areLearningItemsRTL ? "rtl" : "ltr"}
            >
              {learningItems?.map((item) => (
                <li
                  key={item.value}
                  className={`flex items-start break-inside-avoid-column ${areLearningItemsRTL ? "pr-2" : "pl-2"}`}
                >
                  <Image
                    src="/icons/bullet-point-icon.svg"
                    alt=""
                    className={`mt-1 align-middle ${areLearningItemsRTL ? "ml-4" : "mr-4"} `}
                    width={20}
                    height={20}
                  />
                  {item.value}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
